<template>
  <div v-show="isVisible">
    <v-autocomplete
      ref="autocompleteField"
      :label="schema.label || schema.title"
      :class="fieldClasses"
      v-model="fieldValue"
      :items="preparedOptions"
      :autofocus="schema.autofocus"
      :placeholder="schema.placeholder"
      :rules="rules"
      :disabled="disabled || schema.disabled"
      :attach="true"
      @focus="expandMenu"
    />
  </div>
</template>

<script>
import GenericField from './GenericField';

export default {
  name: 'SelectField',
  mixins: [GenericField],
  computed: {
    fieldValue: {
      get() {
        return this.prepareValue(this.localValue);
      },
      set(val) {
        this.localValue = val;
      },
    },
    preparedOptions() {
      return this.prepareOptions();
    },
  },
  methods: {
    formatOptions(options, acc = []) {
      //if an array was passed in, loop through it and add to acc
      if (Array.isArray(options)) {
        // console.log('flat array passed..', options)
        return options.forEach((opt) => {
          this.formatOptions(opt, acc);
        });
      }

      //if options is an object with an options key, then process those..
      if (options.options) {
        // console.log('options.options passed..', options)
        if (Array.isArray(options.options)) {
          return options.options.forEach((opt) => {
            this.formatOptions(opt, acc);
          });
        }
        //if options is an instance with an options key, then process those..
        if (typeof options.options === 'object') {
          return this.formatOptions(options.options, acc);
        }
      }

      if (typeof options === 'string') {
        return acc.push({
          text: options,
          value: options,
        });
      }

      if (typeof options === 'object') {
        if (
          typeof options.text !== 'undefined' &&
          typeof options.value !== 'undefined'
        ) {
          // console.log('text,value options passed', options)
          return acc.push(options);
        }
        // console.log('key value pair passed', options)
        for (const key in options) {
          this.formatOptions(
            {
              text: options[key],
              value: key,
            },
            acc
          );
        }
      }
    },

    prepareOptions() {
      let options = this.schema.options;
      if (!options) return [];

      let formattedOptions = [];
      this.formatOptions(options, formattedOptions);
      return formattedOptions.map(this.normalizeOption);
    },

    normalizeOption(option) {
      return {
        text: this.unescapeHtml(option.text || ''),
        value: this.prepareValue(option.value || ''),
      };
    },

    unescapeHtml(str) {
      return str.replace(/&lt/g, '<').replace(/&gt/g, '>');
    },

    prepareValue(val) {
      return /^[0-9]+$/.test(val) ? +val : val;
    },

    expandMenu() {
      const autocompleteField = this.$refs.autocompleteField;
      if (autocompleteField?.activateMenu) {
        autocompleteField.activateMenu();
      }
    },
  },
};
</script>
